// src/features/modelsSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { modelsApi, type GetModelsResponse } from '~/api/models-api'; // The RTK Query API service

// Define the state interface for models
interface ModelsState {
  models: GetModelsResponse | [];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: ModelsState = {
  models: [],
  status: 'idle',
  error: null,
};

const modelsSlice = createSlice({
  name: 'models',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Handle getModels endpoint actions from RTK Query
    builder
      .addMatcher(modelsApi.endpoints.getModels.matchPending, (state, action) => {
        if (action.meta.arg.originalArgs.select?.length) return;
        state.status = 'loading';
      })
      .addMatcher(modelsApi.endpoints.getModels.matchFulfilled, (state, action) => {
        if (action.meta.arg.originalArgs.select?.length) return;
        state.status = 'succeeded';
        state.models = action.payload;
      })
      .addMatcher(modelsApi.endpoints.getModels.matchRejected, (state, action) => {
        if (action.meta.arg.originalArgs.select?.length) return;
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch models';
      });
  },
});

export default modelsSlice.reducer;
